module.exports = "/_next/static/images/full_orb-2450fecd9e1d3a65ae4e9484c197156e.png";